import { render, staticRenderFns } from "./beginEndorsment.vue?vue&type=template&id=2c94b3c5&scoped=true&"
import script from "./beginEndorsment.vue?vue&type=script&lang=js&"
export * from "./beginEndorsment.vue?vue&type=script&lang=js&"
import style0 from "./beginEndorsment.vue?vue&type=style&index=0&id=2c94b3c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94b3c5",
  null
  
)

export default component.exports